'use client';

import { useSettingsVersion } from '@/hooks/useSettingsVersion';

/**
 * Mount-only component that activates the settings-version polling loop. Rendered once
 * inside QueryProvider so every React Query cache consumer benefits from the push-driven
 * `['players']` invalidation. No UI.
 */
export function SettingsVersionPoller() {
  useSettingsVersion();
  return null;
}
